module.exports = __webpack_public_path__ + "static/media/dropdown-open-sm.f6611fba.svg";